import { combineReducers } from "redux";
import personListReducer from "./personListReducer";
import foodProductListReducer from "./foodProductListReducer";
import landingListReducer from "./landingListReducer";
import nightPlacementListReducer from "./nightPlacementListReducer";
import documentsListReducer from "./orderDocuments";

const listsReducers = combineReducers({
  personList: personListReducer,
  foodProductList: foodProductListReducer,
  landingList: landingListReducer,
  nightPlacement: nightPlacementListReducer,
  documentsList: documentsListReducer
});

export default listsReducers;
